module.exports = __webpack_public_path__ + "static/img/testimony (72).5c89fd7f.jpg";